import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react'
import { RootState } from '../index'

export interface HelpArticle {
  id: string
  slug: string
  title: string
  category: string
  content: string
  tags: string[]
  isVideo?: boolean
  videoDuration?: string
  tipType?: 'info' | 'warning' | 'success'
}

export interface HelpFaq {
  id: string
  slug: string
  question: string
  answer: string
  category: string
}

export interface HelpCenterData {
  articles: HelpArticle[]
  faqs: HelpFaq[]
  contextualTips: string[]
  source?: 'database' | 'defaults' | 'merged'
}

interface HelpApiResponse {
  success: boolean
  data: HelpCenterData
  message?: string
}

export const helpApi = createApi({
  reducerPath: 'helpApi',
  baseQuery: fetchBaseQuery({
    baseUrl: '/api/v1',
    prepareHeaders: (headers, { getState }) => {
      const token = (getState() as RootState).auth.token
      if (token) {
        headers.set('authorization', `Bearer ${token}`)
      }
      return headers
    },
  }),
  tagTypes: ['HelpCenter'],
  endpoints: (builder) => ({
    getHelpCenter: builder.query<HelpCenterData, void>({
      query: () => '/help',
      transformResponse: (response: HelpApiResponse) => response.data,
      providesTags: ['HelpCenter'],
    }),
  }),
})

export const { useGetHelpCenterQuery } = helpApi
